<ul class="{{ root ? 'root' : '' }}">
  <ng-container *ngFor="let node of items">
    <li class="{{ root ? 'root' : '' }}" *ngIf="!node.hide">
      <i
        class="fa fa-{{ node.expanded ? 'minus' : 'plus' }}-square-o"
        (click)="node.expanded = !node.expanded; expand(node)"
      ></i>
      <span class="node-level">#{{ node.networkLevel }}</span>
      <a
        href="javascript: void(0)"
        [ngClass]="{
          'text-red': node.type === 2,
          '': node.type === 1
        }"
        (click)="selectItem(node)"
        >{{ node.text }}</a
      >
      <ng-container *ngIf="node.type === 1">
        <span>
        ({{
          node.totalChildren > 1
            ? node.totalChildren + " references"
            : node.totalChildren + " reference"
        }})
          <!-- , <span class="text-yellow">{{node.earning}}</span>) -->
      </span>
        <i
          class="fa fa-remove text-danger"
          (click)="node.hide = true"
          *ngIf="!root"
        ></i>
      </ng-container>
      <div *ngIf="node.expanded" class="line">
        <fx-treeview
          [items]="node.children"
          [coinType]="coinType"
          (expanded)="onExpanded($event)"
          (slct)="onSelectItem($event)"
        ></fx-treeview>
      </div>
    </li>
  </ng-container>
</ul>
